import { render, staticRenderFns } from "./UuidDecoder.vue?vue&type=template&id=0dc48b10&scoped=true"
import script from "./UuidDecoder.vue?vue&type=script&lang=js"
export * from "./UuidDecoder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc48b10",
  null
  
)

export default component.exports